export const mapAddress = ({address: street, city, postalCode}) => {
  let address = ''

  if (street) {
    address += `${street}`
  }

  if (city || postalCode) {
    if (address.length) address += ', '

    if (postalCode) address += `${postalCode} `
    if (city) address += city
  }

  return address.trim()
}
